import { Anchor, Group } from "@mantine/core";
import type * as React from "react";
import { PANEL_SPACE } from "./tokens";

/**
 * A row action written as a link (Figma "Manage", "Rename", "Remove"): 13px medium in
 * `brand/7`. It is a button, so it works from the keyboard; `label` overrides its accessible
 * name when the visible word needs its row ("Manage" → "Manage a@firm.com"). It passes its
 * ref through, so it can open a menu.
 */
export function LinkAction({
  children,
  onClick,
  label,
  ...rest
}: {
  children: React.ReactNode;
  onClick?: () => void;
  label?: string;
} & Omit<React.ComponentPropsWithRef<"button">, "children" | "onClick" | "color" | "style">) {
  return (
    <Anchor component="button" type="button" size="sm" onClick={onClick} aria-label={label} {...rest}>
      {children}
    </Anchor>
  );
}

/** Several row actions side by side, 10px apart. */
export function LinkActions({ children }: { children: React.ReactNode }) {
  return (
    <Group gap={PANEL_SPACE.field} wrap="nowrap">
      {children}
    </Group>
  );
}
